export { default as NodeEnv } from './application-environments';

export const chromeComponents = {
  HEADER: 'header',
  FOOTER: 'footer',
  PIVOT_NAV: 'pivotNav',
  NAV: 'nav',
} as const;

export type ChromeComponent =
  (typeof chromeComponents)[keyof typeof chromeComponents];
